// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3cJeh","productName":"Table_productName__Icd6V"};